import { render } from "./EditPost.vue?vue&type=template&id=4e0d0d7e"
import script from "./EditPost.vue?vue&type=script&lang=js"
export * from "./EditPost.vue?vue&type=script&lang=js"

import exportComponent from "D:\\xampp\\htdocs\\software.icarusbd.com\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__